<template>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-12 col-md-12">
            <h5 class="card-title">{{ $t('general.countdownUntilPayout') }}</h5>
          </div>
        </div>
        <hr class="mt-0 mb-2">
        <div class="row pt-2 pb-3">
          <div class="col-2 col-md-3 text-center">
            <img class="clock" src="img/icons/clock.png" alt="clock">
          </div>
          <div ref="coutdown" class="col-10 col-md-9 countdown text-center" v-show="!loading">
            {{ countdown }}
          </div>
          <div class="col-10 col-md-9 text-center" v-show="loading">
            <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
          </div>
        </div>
        <div class="row pt-1 pr-0">
          <div class="col-md-9 stake-note">
            ({{ $t('general.mustSteak') }})
          </div>
          <div class="col-md-3 pl-0">
            <hr>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  computed: {
    endDate () {
      const endDateTimeStamp = this.$store.getters.getEndDate

      return new Date(endDateTimeStamp * 1000)
    }
  },
  data () {
    return {
      countdown: '00:00:00',
      loading: true
    }
  },
  methods: {
    getFontSize (time) {
      const baseLength = 8
      const fontSize = 2.7
      const coutdownDiv = this.$refs.coutdown
      const textLength = time.toString().length

      if (baseLength < textLength) {
        const newSize = fontSize * (baseLength / textLength)
        coutdownDiv.style.fontSize = `${newSize}rem`
      } else {
        coutdownDiv.style.fontSize = `${fontSize}rem`
      }
    },
    calculateCountdown () {
      const now = new Date().getTime()
      const distance = this.endDate - now

      if (now > this.endDate) {
        this.countdown = '00:00:00'
      } else {
        const days = Math.floor(distance / (1000 * 60 * 60 * 24))
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)) +
                      (days * 24)
        let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
        let seconds = Math.floor((distance % (1000 * 60)) / 1000)

        minutes = minutes < 10 ? '0' + minutes : minutes
        seconds = seconds < 10 ? '0' + seconds : seconds

        this.countdown = hours + ':' + minutes + ':' + seconds
      }
    }
  },
  mounted () {
    const self = this

    setInterval(() => {
      self.calculateCountdown()
    }, 1000)
  },
  watch: {
    endDate (time) {
      this.loading = false
    },
    countdown (value) {
      this.getFontSize(value)
    }
  }
}
</script>

<style scoped>
hr {
  margin-top: .8rem;
  margin-bottom: 0rem;
}

.card {
  background: rgba(32,37,38, 0.6) 0% 0% no-repeat padding-box;
  box-shadow: 0px 5px 50px #0000001A;
  border-radius: 20px;
  backdrop-filter: blur(49px);
  -webkit-backdrop-filter: blur(49px);
  height: 220px;
}

.card-title {
  font: normal normal 600 17px Poppins;
  letter-spacing: 0px;
}

.clock {
  width: 94px;
  height: 94px;
  position: fixed;
  left: -1.2rem;
}

.countdown {
  font-weight: 900;
  padding-left: 0;
  padding-top: .5rem;
  padding-bottom: .5rem;
  font: normal normal 600 45px Poppins;
  letter-spacing: 0px;
}

.stake-note {
  margin-top: .5rem;
  font-size: .6rem;
  color: #707070;
}
</style>
